import { UserState } from 'app/home/global-store/user/user.model';

export const userInitialState: UserState = {
  storeStatus: undefined,
  userType: 'default',
  entryType: undefined,
  isQuoting: false,
  kinId: undefined,
  kinPersonId: undefined,
  kinSegmentId: '',
};
